<template>
  <b-modal
    :id="'workOrder-notes-modal' + workOrder.id"
    :ref="'workOrder-notes-modal' + workOrder.id"
    modal-class="modal-fullscreen"
    centered
    no-close-on-backdrop
    scrollable
    title="Work order notes"
    size="lg"
    hide-footer
    @show="getWorkOrderNotes()"
    @hidden="resetForm()"
  >
    <VehicleDetails
      v-if="vehicle"
      :vehicle="vehicle"
      :color="vehicle.vehicleInformation.color || '----'"
    />
    <NoteRegistrationForm
      v-if="userHasPermission('wo', 'write')"
      :vehicle="vehicle"
      :refreshData="getWorkOrderNotes"
      :workOrder="workOrder"
    />
    <b-list-group v-if="isLoading" class="mt-2">
      <b-list-group-item class="text-center">
        <b-spinner variant="yellow" />
      </b-list-group-item>
    </b-list-group>
    <b-list-group v-else class="mt-2 mb-2 note-list" tag="ul">
      <b-list-group-item v-if="notes && !notes.length" class="text-center">
        <b>No notes to show</b>
      </b-list-group-item>

      <b-list-group-item
        v-for="(note, i) in notes"
        :key="i"
        class="flex-column align-items-start"
        tag="li"
      >
        <NoteCard :note="note" :refreshData="getWorkOrderNotes" />
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { GET_WORK_ORDER_NOTES } from "./actions";
import { superAdminMixin } from "@/modules/superAdmin/mixins.js";
import NoteRegistrationForm from "./RegistrationForm";
import VehicleDetails from "@/modules/superAdmin/components/VehicleDetails.vue";
import NoteCard from "./NoteCard.vue";
export default {
  name: "WorkOrderNotesModal",
  components: { NoteRegistrationForm, VehicleDetails, NoteCard },
  mixins: [superAdminMixin],
  props: ["workOrder"],
  computed: {
    ...mapState({
      vehicle: (state) => state.superAdminStore.vehicle,
      /*   notes: (state) => state.vehicle.workOrder.notes.notes, */
    }),
  },
  data() {
    return {
      notes: null,
      isLoading: false,
    };
  },
  mounted() {},
  methods: {
    resetForm() {},
    changePage(page) {
      this.$store.commit(GET_WORK_ORDER_NOTES, {
        fields: { page },
      });
      this.getNotes();
    },
    getWorkOrderNotes() {
      this.isLoading = true;
      this.$store
        .dispatch(GET_WORK_ORDER_NOTES, {
          id: this.workOrder.id,
        })
        .then((response) => {
          this.notes = [];
          this.notes = response.workOrder;
          this.$parent.getWorkOrderNotes();
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.resize-none {
  resize: none;
}
.note-list {
  max-height: 500px;
  overflow-y: auto;
}
</style>
